var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,2.6c-1.6-1.6-3.8-2.5-6.1-2.5H8.7C6.4,0.1,4.2,1,2.6,2.6S0.1,6.4,0.1,8.7v38.6c0,2.3,0.9,4.5,2.5,6.1 c1.6,1.6,3.8,2.5,6.1,2.5h38.6c2.3,0,4.5-0.9,6.1-2.5c1.6-1.6,2.5-3.8,2.5-6.1V8.7C55.9,6.4,55,4.2,53.4,2.6z M54.4,47.3 c0,1.9-0.7,3.7-2.1,5c-1.4,1.4-3.1,2.1-5.1,2.1H8.7c-1.9,0-3.7-0.7-5.1-2.1c-1.4-1.4-2.1-3.1-2.1-5V8.7c0-1.9,0.7-3.7,2.1-5 s3.1-2.1,5.1-2.1h38.6c1.9,0,3.7,0.7,5.1,2.1c1.4,1.4,2.1,3.1,2.1,5V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,6.9c-9,0-16.4,7.4-16.4,16.5c0,3.2,0.9,6.3,2.7,9l0,0.1c0.2,0.3,0.4,0.6,0.6,0.9l11.2,14.5c0,0,0,0,0,0 l0.6,0.8v-0.8c0-5.6-1.7-7.8-2.3-8.7c-0.1-0.2-0.1-0.5-0.1-0.8c0-0.1,0.1-0.2,0.2-0.2c1.1,0.3,2.3,0.5,3.5,0.5 c1.2,0,2.3-0.2,3.5-0.5c0.1,0,0.2,0.1,0.2,0.2c0,0.3,0,0.6-0.1,0.8c-0.6,0.9-2.3,3.1-2.3,8.7v0.7l0.8-1c0,0,0,0,0,0L41,33.6 c2.3-2.9,3.4-6.4,3.4-10.1C44.4,14.3,37.1,6.9,28.1,6.9z M36.1,34.2c-2.4,1.7-5.1,2.7-8,2.7c-4.4,0-8.5-2.1-11-5.6 c-4.4-6.1-3.1-14.7,3-19.2c2.4-1.7,5.1-2.6,8-2.6c4.4,0,8.5,2.1,11,5.6C43.5,21.1,42.2,29.7,36.1,34.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsLogo);
export default __webpack_public_path__ + "static/media/GSLogo.5c1bec685f446eeb6945beed9b207751.svg";
export { ForwardRef as ReactComponent };